import { useState , useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import config from "../config";

const useLogin = () => {
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [schoolCode, setSchoolCode] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();
  
    const handleLogin = async () => {
        if (!schoolCode || !password) {
            Swal.fire("warning", "Please enter Centre Code and Password", "warning");
            return;
        }
        setLoading(true);
        try {
            const response = await fetch(`${config.API_BASE_URL}/Auth/Login`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    loginid: schoolCode,
                    password: password,
                }),
            });

            let data;
            try {
                data = await response.json();
            }
            catch (err) {
                throw new Error("Invalid JSON response");
            }

            // console.log(data);

            if (response.ok) {
                console.log(data);
                const sessionId = new Date().getTime(); 
                localStorage.setItem("token2", data.data.token);
                localStorage.setItem("sessionId2", sessionId); 
                window.dispatchEvent(new Event("storage")); 
                navigate("/board-dashboard");
            } else {
                Swal.fire("Error", data?.message || "Invalid login credentials", "error");
            }
        }
        catch (error) {
            console.error("Login error:", error);
            Swal.fire("Error", "Something went wrong. Try again later.", "error");
        }
        finally {
            setLoading(false);
        }
    };

    return {
        loading,
        showPassword,
        schoolCode,
        password,
        setShowPassword,
        setSchoolCode,
        setPassword,
        handleLogin,
    };
};

export default useLogin;
